/**
* This is the Login component which handles user login and signup functionality.
*
* @param {Object} intl - Internationalization object used for translation
* @returns {ReactElement}
*/
import React, { useState } from 'react';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faLock } from '@fortawesome/fontawesome-free-solid';
import logo_vnpt from 'assets/imgs/logo_home.png';
import telephone from 'assets/imgs/telephone_2.png';
import icon_4g from 'assets/imgs/4g_icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { I18nService, InputText, KCSModal, Notification } from 'components';
import { Button, Modal } from 'react-bootstrap';
import { UserService } from 'services/UserService';
import { FormattedMessage, useIntl } from 'react-intl';
import Signup from './Component/Signup';
import ForgotPassword from './Component/ForgotPassword';
import ResetPassword from './Component/ResetPassword';
import { useHistory } from 'react-router-dom';
import { URL_LOGIN_3G } from 'global/environment';
import {
  doGetMsisdn,
  doGetUserInfoLoyalty,
  doGetUserInfoVplus,
  doGetUserPromoMenu,
  doLogin,
  doLoginLoyalty,
  doLoginVplus,
  doLogoutLoyalty,
  doLogoutVplus,
  doTokenDevVplus,
  doTokenHoiVienEscVplus,
  doTokenHoiVienVplus
} from 'store/action/userAction';
import { CommonService } from 'services/CommonService';
import { VPlusService } from 'services/VPlusService';
import {LIST_VNPP_TITLE_LOGOUT} from 'pages/Header/Header';
import {LoyaltyService} from "../../services/LoyaltyService";

const md5Hex = require('md5-hex');

const Login = ({ isOpenModalLogin, closeModalLogin, showDes, message = "", setListVNPPTitle, handleVPlusCheckRegister }) => {
  const [step, setStep] = useState(0);
  const [tab, setTab] = useState(0);
  const [otp, setOtp] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [renewPassword, setRenewPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [errorMsg2, setErrorMsg2] = useState('');
  const [isOpenModal, setOpenModal] = useState(false);
  const [content, setContent] = useState('');
  const { FCMToken } = useSelector(state => state.authorizedReducer);

  const dispatch = useDispatch();
  const intl = useIntl();
  const history = useHistory();

  const handlePhoneNumber = (value) => {
    setPhoneNumber(value)
    const test = CommonService.REGEX_PHONE_NUMBER.test(value);
    if (!test || value.length > 11) {
      setErrorMsg(intl.formatMessage({ id: 'IDS_ERROR_ISDN_LONG' }));
    } else {
      setErrorMsg('')
    }
  }

  const isDisabled = () => {
    return errorMsg || phoneNumber.length === 0;
  }

  const loginByPass = () => {
    if (!phoneNumber) {
      setErrorMsg(intl.formatMessage({ id: 'IDS_SNHAPSODIENTHOAI' }));
    } else {
      setStep(2);
    }
  }

  // const onBack = () => {
  //   if (step === 1 || step === 2) {
  //     setStep(0);
  //   } else {
  //     setStep(step - 1);
  //   }
  //   setOtp('')
  // }

  const sendOTP = (isForgotPassword) => {
    if (isDisabled()) {
      return;
    }
    const data = {
      // for_test: '84824888193',
      msisdn: phoneNumber,
      otp_service: isForgotPassword === true ? "authen_miss_password" : "authen_msisdn"
    };

    UserService.sendOTP(data, res => {
      if (res.error_code === '0') {
        Notification.success(res.message || intl.formatMessage({ id: 'IDS_SEND_OTP_SUCCESS' }));
        if (isForgotPassword !== true) {
          setStep(1);
        } else if (step === 3) {
          setStep(4);
        }
      } else {
        Notification.error(res.message || intl.formatMessage({ id: 'IDS_TV_LOI_OTP' }));
      }
    }, (res) => {
      Notification.error(res.message || intl.formatMessage({ id: 'IDS_TV_LOI_OTP' }));
    });
  }

  const handleLogin = (mode) => {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
      userAgent = 'Opera';
    }
    else if (navigator.userAgent.indexOf("Edg") != -1) {
      userAgent = 'Edge';
    }
    else if (navigator.userAgent.indexOf("Chrome") != -1) {
      userAgent = 'Chrome';
    }
    else if (navigator.userAgent.indexOf("Safari") != -1) {
      userAgent = 'Safari';
    }
    else if (navigator.userAgent.indexOf("Firefox") != -1) {
      userAgent = 'Firefox';
    }
    else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
    {
      userAgent = 'IE';
    }
    else {
      userAgent = 'unknown';
    }

    //eku_3_FcQvU:APA91bGMDX0optWjFWpkkdpKjasD44RYPaIYsvVilyPub1Tq2DV41G75NvmHk09ZIm_qFtUzN5iSj4wcN7BiG-xpSsuTKJOucCERqcIY0L9ogfqBFJqm6waBaE8GA6EYmPpYNWDpF1g4
    const data = {
      device_info: userAgent,
      fcm_registration_token: FCMToken,
      mode: mode,
      msisdn: phoneNumber,
      password: mode === 'otp' ? otp : md5Hex(password)
    };

    if (mode === 'password' && !password) {
      setErrorMsg2(intl.formatMessage({ id: 'IDS_VALIDATION_VPLUS_USERNAME_LENGTH' }));
      return;
    }

    UserService.login(data, resLogin => {
      if (resLogin.error_code === '0') {
        localStorage.setItem('mobile', resLogin.msisdn);
        localStorage.setItem('session', resLogin.session);
        localStorage.setItem('authorized', true);
        localStorage.setItem('off_net', resLogin.off_net);

        LoyaltyService.getMemberInfo(null, (resCheckLoyalty) => {
          if (resCheckLoyalty?.errorCode == "37") {
            localStorage.setItem("flowType", "Vplus");
            handleLoginVplus(resLogin?.msisdn);
          } else {
            localStorage.setItem("flowType", "Loyalty");
            localStorage.setItem("loyaltyErrorCode", resCheckLoyalty?.errorCode);
            dispatch(doGetUserInfoLoyalty(resCheckLoyalty?.result))
            localStorage.setItem("loyalty_userInfo", JSON.stringify(resCheckLoyalty?.result));
            if (resCheckLoyalty?.errorCode == "0") {
              handleUuDaiMenuLoyalty();
              dispatch(doLoginLoyalty());
              localStorage.setItem("loyalty_authorized", true);
            } else {
              dispatch(doLogoutLoyalty());
              localStorage.setItem("loyalty_authorized", false);
              localStorage.setItem('vplus_promoMenu', JSON.stringify(LIST_VNPP_TITLE_LOGOUT))
              dispatch(doGetUserPromoMenu(LIST_VNPP_TITLE_LOGOUT));
              setListVNPPTitle(LIST_VNPP_TITLE_LOGOUT);
            }
            // handleLoginVplus(resLogin?.msisdn);
          }
        }).then(r => r);

        dispatch(doGetMsisdn(resLogin.msisdn));
        dispatch(doLogin());
        closeModalLogin();
        Notification.success(resLogin.message || intl.formatMessage({id: 'IDS_LOGIN_OTP_SUCCESS'}));
      } else {
        setOpenModal(true);
        setContent(resLogin.message || intl.formatMessage({id: 'IDS_LOGIN_FAILED'}));
      }
    }, (res) => {
      setOpenModal(true);
      setContent(res.message || intl.formatMessage({id: 'IDS_LOGIN_FAILED'}));
    });
  }

  const handleUuDaiMenuLoyalty = () => {
    LoyaltyService.getPromotionalCategories({categoryIdList: null}, (res) => {
      if (res?.errorCode == "0" && res?.result) {
        const dataListUuDai = res?.result;
        const promoSubmenu = [];
        dataListUuDai.forEach(item => {
          promoSubmenu.push({
            name: item?.categoryInfo?.name,
            href: `/vinaphone-plus/promotions?id=${item?.categoryInfo?.id}`
          });
        });
        const promoMenu = [
          {
            title: 'IDS_VINAPHONE_PLUS',
            url: '/vinaphone-plus',
            menuList: [
              {
                name: 'IDS_MENBER_INFO',
                href: '/vinaphone-plus',
                subMenuList: [
                  {name: 'IDS_MEMBER_CARD', href: '/', canOpenMeminfo: true},
                  {
                    name: 'IDS_POINT_MANAGEMENT',
                    href: '/vinaphone-plus/point-history',
                    subMenuList: [
                      {name: 'IDS_POINT_SERVICE', href: '/vinaphone-plus/point-service'},
                    ],
                  },
                  {name: 'IDS_MEMBER_PRIVILEGES', href: '/vinaphone-plus/membership-benefits'},
                  {
                    name: 'IDS_MY_PROMOTIONS',
                    href: '/vinaphone-plus/offer?tabIndex=1',
                    subMenuList: [
                      {name: 'IDS_VOUCHER_PROMOTIONS', href: '/vinaphone-plus/offer?tabIndex=1'},
                      {name: 'IDS_GIFT_PROMOTIONS', href: '/vinaphone-plus/offer?tabIndex=2'},
                      {name: 'IDS_PROMOTION_USAGE_HISTORY', href: '/vinaphone-plus/voucher-history'},
                    ],
                  },
                ]
              },
              {name: 'IDS_PROMOTION_PROGRAM', href: '/vinaphone-plus/promotions', subMenuList: promoSubmenu},
              {name: 'IDS_ABOUT_VINAPHONE_PLUS', href: '/vinaphone-plus/about'},
              {name: 'IDS_VINAPHONE_PLUS_PARTNERS', href: '/vinaphone-plus/about?key=becomePartner'}
            ]
          },
        ]
        localStorage.setItem('vplus_promoMenu', JSON?.stringify(promoMenu));
        dispatch(doGetUserPromoMenu(promoMenu));
        setListVNPPTitle(promoMenu);
      }
    }).then(r => r);
  }

  const handleLoginVplus = (msisdn) => {
    const dataToken = {
      domain: 'quantri',
      msisdn
    };
    VPlusService.getTokenHoiVien(dataToken, res => {
      if (res?.errorCode == '0') {
        dispatch(doTokenDevVplus(res?.result?.TokenDev));
        dispatch(doTokenHoiVienEscVplus(res?.result?.TokenHoiVienEsc));
        dispatch(doTokenHoiVienVplus(res?.result?.TokenHoiVien));
        localStorage.setItem('vplus_TokenHoiVien', res?.result?.TokenHoiVien);
        localStorage.setItem('vplus_TokenDev', res?.result?.TokenDev);
        localStorage.setItem('vplus_TokenHoiVienEsc', res?.result?.TokenHoiVienEsc);

        // TokenHoiVienEsc: "" => Khách hàng không phải là hội viên
        // ERRORCODE: "IS_VNP_CUSTOMER_00" => Khách hàng của VNP
        // ERRORCODE: "IS_VNP_CUSTOMER_01" => Không phải khách hàng của VNP
        // if (res?.result?.ERRORCODE === "ERR-COD-90001") {
        if (res?.result?.hoivienVinaphonePlus === 0) {
          dispatch(doGetUserInfoVplus(res?.result));
          dispatch(doLogoutVplus());
          localStorage.setItem('vplus_userInfo', JSON.stringify(res?.result));
          localStorage.setItem('vplus_authorized', false);
          localStorage.setItem('vplus_promoMenu', JSON.stringify(LIST_VNPP_TITLE_LOGOUT))
          dispatch(doGetUserPromoMenu(LIST_VNPP_TITLE_LOGOUT));
          setListVNPPTitle(LIST_VNPP_TITLE_LOGOUT);
          if (window.location.pathname.includes('vinaphone-plus')) {
            handleVPlusCheckRegister();

            window.location.assign('/');
          }
        } else {
          dispatch(doLoginVplus());
          localStorage.setItem('vplus_authorized', true);
          localStorage.setItem('vplus_isAddEmail', true);

          let data = {
            token: res?.result?.TokenHoiVienEsc,
            msisdn
          }
          getLayThongTinChungMobile(data);
        }
      }
    });
  }

  const getLayThongTinChungMobile = (data) => {
    VPlusService.getLayThongTinChungMobile(data, res => {
      if (res?.errorCode === "0") {
        if (res?.result) {
          dispatch(doGetUserInfoVplus(res?.result))
          localStorage.setItem('vplus_userInfo', JSON.stringify(res?.result));
        }

        const paramDanhMucUuDai = {
          parentCategoryId: -1,
          status: 1,
          priority: "asc",
          LoaiUuDai_Hang: res?.result?.ThongTinHoiVien?.HangHoiVienMoiId,
          msisdn: data.msisdn
        }
        VPlusService.getDanhMucUuDai(paramDanhMucUuDai, res => {
          if (res?.errorCode === "0") {
            const data = res?.result
            if (data) {
              let promoSubmenu = []
              data.forEach(item => {
                promoSubmenu.push({ name: item.categoryNameVie, href: `/vinaphone-plus/promotions?id=${item.id}` })
              });
              // setListVNPPTitle(LIST_VNPP_TITLE_LOGIN)
              const promoMenu = [
                {
                  title: 'IDS_VINAPHONE_PLUS',
                  url: '/vinaphone-plus',
                  menuList: [
                    {
                      name: 'IDS_MENBER_INFO',
                      href: '/vinaphone-plus',
                      subMenuList: [
                        { name: 'IDS_MEMBER_CARD', href: '/', canOpenMeminfo: true},
                        {
                          name: 'IDS_POINT_MANAGEMENT',
                          href: '/vinaphone-plus/point-history',
                          subMenuList: [
                            { name: 'IDS_POINT_SERVICE', href: '/vinaphone-plus/point-service' },
                          ],
                        },
                        { name: 'IDS_MEMBER_PRIVILEGES', href: '/vinaphone-plus/membership-benefits' },
                        {
                          name: 'IDS_MY_PROMOTIONS',
                          href: '/vinaphone-plus/offer?tabIndex=1',
                          subMenuList: [
                            { name: 'IDS_VOUCHER_PROMOTIONS', href: '/vinaphone-plus/offer?tabIndex=1' },
                            { name: 'IDS_GIFT_PROMOTIONS', href: '/vinaphone-plus/offer?tabIndex=2' },
                            { name: 'IDS_PROMOTION_USAGE_HISTORY', href: '/vinaphone-plus/voucher-history' },
                          ],
                        },
                      ]
                    },
                    { name: 'IDS_PROMOTION_PROGRAM', href: '/vinaphone-plus/promotions', subMenuList: promoSubmenu },
                    { name: 'IDS_ABOUT_VINAPHONE_PLUS', href: '/vinaphone-plus/about' },
                    { name: 'IDS_VINAPHONE_PLUS_PARTNERS', href: '/vinaphone-plus/about?key=becomePartner' }
                  ]
                },
              ]
              localStorage.setItem('vplus_promoMenu', JSON.stringify(promoMenu))
              dispatch(doGetUserPromoMenu(promoMenu))
              setListVNPPTitle(promoMenu)
            }
          }
        })
      }
    })
  }

  const changePassword = () => {
    const data = {
      otp: otp,
      msisdn: phoneNumber,
      password: md5Hex(newPassword)
    };

    UserService.missPassword(data, res => {
      if (res.error_code === '0') {
        Notification.success(intl.formatMessage({ id: 'IDS_TV_DOI_MAT_KHAU_THANH_CONG' }));
        closeModalLogin();
        return;
      }
      setContent(res.message || intl.formatMessage({ id: 'IDS_TV_LOI_OTP' }));
      setOpenModal(true);
    });
  }

  const onLogin3G = () => {
    window.location.href = `${URL_LOGIN_3G}${history.location.pathname}${history.location.search}`;
  }
  let messageStr = message
  if (messageStr === "" || messageStr === undefined) {
    messageStr = intl.formatMessage({ id: 'IDS_LOGIN_DESCRIPTION' })
  }
  // STEP = 0
  const loginActionScreen = () => {
    return (
      <div>
        {showDes && <p className="red mb-3 text-center">{messageStr}</p>}
        <div className="position-relative">
          <FontAwesomeIcon
            color="#007bff"
            icon={faMobileAlt}
            size="2x"
            className="login__icon-mobile"
          />
          <InputText
            value={phoneNumber}
            handleOnChange={handlePhoneNumber}
            placeholder={intl.formatMessage({ id: 'IDS_TV_REQUEST_PHONE_NUMBER' })}
            errorMsg={errorMsg}
            onlyNumber
            onEnter={sendOTP}
          />
        </div>
        <Button disabled={isDisabled()} className="login__btn" onClick={sendOTP}>
          <FormattedMessage id='IDS_TV_LOGINNEW_GUIOTP' /></Button>
        <div className="login__or-text"><span><FormattedMessage id='IDS_SLOGINOR' /></span></div>
        <div className="login__by-pass margin-top-20 pointer" onClick={loginByPass}>
          <FormattedMessage id='IDS_SLOGINMK' /></div>

        <div className="d-lg-none">
          <div className="login__3g-btn" onClick={onLogin3G}>
            <img alt="4g" src={icon_4g} />
            <FormattedMessage id='IDS_LOGIN_BY_3G' />
          </div>
        </div>
      </div>
    );
  }

  // STEP = 1
  const confirmOTPScreen = () => {
    const phoneSlice = phoneNumber?.slice(0, -3) + 'xxx';

    return (
      <div className="login__confirm">
        <div className="phone-icon mb-4">
          <img alt="phone" src={telephone} />
          <span>{phoneSlice}</span>
        </div>
        <InputText
          value={otp}
          handleOnChange={(value) => setOtp(value)}
          placeholder={intl.formatMessage({ id: 'IDS_TV_FORM_OTP' })}
          onEnter={() => handleLogin('otp')}
          onlyNumber
        />

        <Button className="login__btn mt-4" onClick={() => handleLogin('otp')}>
          <FormattedMessage id='IDS_TV_SIGN_IN' />
        </Button>
        <div className="login__sign-up margin-top-20">
          {I18nService('IDS_SRESENDOTP', { intl, onClick: sendOTP })}
        </div>
      </div>
    )
  };

  // STEP = 2
  const loginPasswordScreen = () => (
    <div className="login__confirm position-relative">
      <FontAwesomeIcon
        color="#007bff"
        icon={faLock}
        size="lg"
        className="login__icon-mobile"
      />
      <InputText
        value={password}
        handleOnChange={(value) => setPassword(value)}
        onEnter={() => handleLogin('password')}
        placeholder={intl.formatMessage({ id: 'IDS_VPLUS_SIGNUP_PASSWORD' })}
        errorMsg={errorMsg2}
        isPassword
      />
      <div className="login__by-pass pointer mt-2" onClick={() => setStep(3)}>
        <FormattedMessage id='IDS_TV_FORGET_PASSWORD' /></div>
      <Button className="login__btn mt-4" onClick={() => handleLogin('password')}>
        <FormattedMessage id={'IDS_TV_SIGN_IN'} />
      </Button>
    </div>
  )

  return (
    <>
      <Modal show={isOpenModalLogin} onHide={closeModalLogin}
        className={`login ${isOpenModal ? 'is-blurred' : ''}`}>
        <Modal.Header closeButton>
          {/* {step !== 0 &&
            <FontAwesomeIcon
              color="#004f9e"
              onClick={onBack}
              className="login__arrow"
              icon={faArrowLeft}
              size="lg"
            />
          } */}
        </Modal.Header>

        <Modal.Body className="login__content">
          <div className="text-center">
            <img alt="logo" src={logo_vnpt} className="login__logo" />
          </div>
          <div className="login__tab">
            <h3 className={tab === 0 ? 'tab-active' : ''} onClick={() => setTab(0)}>
              <FormattedMessage id='IDS_TV_SIGN_IN' /></h3>
            <h3 className={tab === 1 ? 'tab-active' : ''} onClick={() => setTab(1)}>
              <FormattedMessage id='IDS_SDANGKY' /></h3>
          </div>

          {tab === 0 &&
            <>
              {step === 0 && loginActionScreen()}
              {step === 1 && confirmOTPScreen()}
              {step === 2 && loginPasswordScreen()}
              {step === 3 &&
                <ForgotPassword
                  phoneNumber={phoneNumber}
                  handlePhoneNumber={handlePhoneNumber}
                  errorMsg={errorMsg}
                  sendOTP={sendOTP}
                  intl={intl}
                />
              }
              {step === 4 &&
                <ResetPassword
                  otp={otp}
                  setOtp={setOtp}
                  newPassword={newPassword}
                  setNewPassword={setNewPassword}
                  renewPassword={renewPassword}
                  setRenewPassword={setRenewPassword}
                  changePassword={changePassword}
                  intl={intl}
                />
              }
            </>
          }
          {tab === 1 && <Signup closeModalLogin={closeModalLogin} />}

        </Modal.Body>
      </Modal>

      <KCSModal
        isOpenModal={isOpenModal}
        title="Thông báo"
        content={content}
        closeModal={() => setOpenModal(false)}
      />
    </>
  );
}

export default React.memo(Login);
